"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function stq(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M4.61481 6.08914C5.41806 6.08914 6.24831 6.03514 7.05231 6.10714C7.40931 6.50839 7.48956 7.07089 7.76631 7.53514C11.3738 7.55314 14.9986 7.53514 18.6061 7.53514C18.8738 7.55314 19.2038 7.56214 19.3381 7.82989C19.4986 8.12464 19.3831 8.47264 19.2308 8.74039C18.4988 9.98164 17.8021 11.2409 17.0881 12.4904C16.8203 12.9374 16.6411 13.4369 16.2398 13.7856C15.9098 14.0624 15.4538 14.0796 15.0346 14.0796H10.0336C9.76581 14.0796 9.48006 14.0534 9.31956 13.8389C8.80206 13.2584 8.52456 12.5174 8.18556 11.8386C7.59849 10.6633 7.02396 9.48173 6.46206 8.29414C6.34581 8.02639 6.20331 7.78564 6.06906 7.53514C5.59656 7.53514 5.12256 7.53514 4.65906 7.51714C4.56906 7.04464 4.56906 6.56239 4.61406 6.08914H4.61481ZM10.2488 15.0441C10.6121 14.9578 10.9899 14.9517 11.3558 15.0261C11.7661 15.1161 12.1238 15.4281 12.2221 15.8391C12.3286 16.3116 12.3286 16.8216 12.1411 17.2761C11.9626 17.6871 11.5163 17.8836 11.0971 17.9196C10.6148 17.9549 10.0613 17.9196 9.70356 17.5619C9.32031 17.1336 9.32031 16.5089 9.40056 15.9726C9.45381 15.5264 9.81081 15.1424 10.2481 15.0441H10.2488ZM14.7128 15.0441C15.1591 14.9466 15.6413 14.9549 16.0703 15.1154C16.4806 15.2856 16.6951 15.7319 16.7303 16.1511C16.7843 16.6424 16.7303 17.2049 16.3733 17.5799C16.0433 17.8926 15.5611 17.9369 15.1238 17.9279C14.6948 17.9106 14.2313 17.7494 14.0078 17.3481C13.7948 16.913 13.7379 16.4178 13.8466 15.9456C13.9366 15.5084 14.2756 15.1431 14.7128 15.0441Z", fill: color }));
}
exports["default"] = stq;
//# sourceMappingURL=stq.js.map